import request from '@/utils/request'
const BASE_URL = '/EquipmentRealtimedata'

//系统
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  getLastInfo(equipmentId){
    return request({
      url: BASE_URL + '/getLastInfo',
      method: 'get',
      params:{equipmentId}
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
 
 
}